import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { AuthProvider } from '@/lib/auth/auth-context';
import { MyPermissionsProvider } from '@/lib/auth/my-permissions';
import { OutletProvider } from '@/contexts/OutletContext';
import { AppRoutes } from './routes';
import '@/app/globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <I18nextProvider i18n={i18n}>
        <AuthProvider>
          <MyPermissionsProvider>
            <OutletProvider>
              <AppRoutes />
            </OutletProvider>
          </MyPermissionsProvider>
        </AuthProvider>
      </I18nextProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
